import { render, staticRenderFns } from "./GenreButton.vue?vue&type=template&id=fcb30fc0&scoped=true&"
import script from "./GenreButton.vue?vue&type=script&lang=js&"
export * from "./GenreButton.vue?vue&type=script&lang=js&"
import style0 from "./GenreButton.vue?vue&type=style&index=0&id=fcb30fc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb30fc0",
  null
  
)

export default component.exports